import { Link } from "react-router-dom";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { useState } from "react";
import { useOverlayTrigger } from "@/hooks/useOverlayTrigger";

const navItems = [
  { label: "Artists", href: "/artists" },
  { label: "Sponsors", href: "/sponsors" },
  { label: "Playlists", href: "/playlists", isNew: true },
  { label: "Songs", href: "/songs" },
  { label: "Community", href: "/community" },
  { label: "Charts", href: "/charts" },
  { label: "Discover", href: "/profiles" },
  { label: "Plans", href: "/plans" },
];

export function MobileNavDrawer() {
  const [open, setOpen] = useState(false);
  useOverlayTrigger(open);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="lg:hidden h-12 w-12 hover:bg-transparent hover:text-current [&_svg]:size-8"
        >
          <Menu className="text-navbar-foreground" strokeWidth={1.5} />
          <span className="sr-only">Open menu</span>
        </Button>
      </SheetTrigger>
      <SheetContent side="right" className="bg-black/95 border-white/10 w-64 flex flex-col p-0">
        <SheetHeader className="px-6 pt-6 pb-2 shrink-0">
          <SheetTitle className="text-white text-left">Menu</SheetTitle>
        </SheetHeader>
        <nav className="flex flex-col gap-1 mt-2 px-4 pb-6 overflow-y-auto flex-1">
          {navItems.map((item) => (
            <Link
              key={item.href}
              to={item.href}
              onClick={() => setOpen(false)}
              className="flex items-center gap-2 px-3 py-2.5 text-base text-gray-300 hover:text-primary-light hover:bg-white/5 rounded-lg transition-colors"
            >
              <span>{item.label}</span>
              {item.isNew && (
                <span className="bg-primary text-primary-foreground text-[10px] font-semibold px-1.5 py-0.5 rounded-full uppercase">
                  New
                </span>
              )}
            </Link>
          ))}
        </nav>
      </SheetContent>
    </Sheet>
  );
}
